// This lets us clear the value and still update the input render
export function getValue(
  value: string | typeof undefined | string[] | number
): string | typeof undefined | string[] | number {
  if (value === "") return value;
  if (!value) return undefined;
  return value;
}
